import { render } from "./SimilarCarsContainer.vue?vue&type=template&id=b1a80894"
import script from "./SimilarCarsContainer.vue?vue&type=script&lang=js"
export * from "./SimilarCarsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__